import Vue from "vue";

export const TermConditionEventBus = new Vue();
export const TermConditionOptionsEventBus = new Vue();
